module.exports = __webpack_public_path__ + "resources/img/mark_29100_lg.ce0fd55a3e262cd7c71ae9019c644d01.png";